//@getters

import { GetterTree } from "vuex";
import { profileState } from "./state";

export const getters: GetterTree<any, profileState> = {};
